
import constant from './modules/constant/constant_zh'
import file from './modules/file/file_zh'
import table from './modules/table/table_zh'
import operationLog from './modules/oplog/operationLog_zh'
import search from './modules/search/search_zh'
import placeholder from './modules/placeholder/placeholder_zh'
import errMsg from './modules/error/errMsg_zh'
import qbLog from  './modules/oplog/qbLog_zh'
import confirm from './modules/confirm/confirm_zh'
import html from './modules/constant/html_zh'
import order from './modules/order/order_zh'

import payLog from './modules/oplog/PayLog_zh';
import store from './modules/store/store_zh';


export default {
  message: {
    modiyAccountError:"拒绝，该账号已被修改",
    expirationData:'到期数据',//
    orderData:"订单数据",
    qbData:"qb数据",
    imeiCard:"卡imei",
    iccidCard:"卡iccid",
    recentlyLoggedOut:"登出时间",
    recentLogin:"登录时间",
    taskUser:'任务用户',
    taskManagement:'任务管理',
    taskManage:'任务管理',
    patrolFile:'文件管理',
    patrolEvent:'上报事件',
    patrolSignCount:'签到统计',
    patrolStatistics:'巡更统计',
    patrolUserPlan:'设置用户计划',
    patrolPlanUser:'查看用户计划',
    patrolPlanGroup:'巡更计划组',
    patrolPlan:'巡更计划',
    patrolGroup:'巡更路线(点分组)',
    patrolPoints:'巡更点',
    patrolManage:'巡更管理',
    entManage808:'808转换设备',
    track808:'808id管理',
    decorationIndex:"个性化",
    priceRecord:"价格操作记录",//价格操作记录
    RecycleFromTarget:"把分出去的货币从目标上回收",//把分出去的货币从目标上回收
    allocateToTarget:"把货币分配给目标",//把货币分配给目标
    targetBalance:"目标账号余额",//目标账号余额
    currentBalance:"当前账号余额",//当前账号余额
    virtualCurrency:"虚拟货币",//虚拟货币
    myBalance:"我的余额",//我的余额
    enterpriseBalance:"企业余额",//企业余额
    doNotAddingFeatures:"只增加功能时不要选择续签时长",//
    selectTargetCom:"请选择目标企业!",//请选择目标企业
    numberOfAccountsCannotEqual:"改签账号数不能等于拥有数!",//改签账号数不能等于拥有数
    purchaseOrderFailed:"购买订单失败，余额不足！",//购买订单失败，余额不足！
    changeAccountNumberCannotBeLessThan1:"改签账号不能小于1！",//改签账号不能小于1
    maximumOrderQuota:"订单名额上限",//订单名额上限
    organizationAuthority:'组织权限',
    entManage:'专网企业',
    privateNetworkManage:'专网管理',
    pnIDManage:'专网id管理',
    secmerSave:'扫描新增',
    secmerOrganization:'组织转移',
    secmerCheckinIccid:'接入导出',
    seconOrganization:'组织结构',
    seconErpriseRelevanList:'关联列表',
    seconErpriseRelevan:'关联群组',
    seconErpriseOrgan:'组织群组',
    seconErpriseMonitor:'二级监听',
    orderUserBindLog:"换绑记录",
    organManagement:'组织管理',
    terminalMonitor:'终端监听',
    relevanceGroupList:'关联列表',
    relevanceGroup:'关联群组',
    groupOrganization:'组织群组',
    OrganizationalManagement:'组织管理',
    groupStructure:'组织群组',
    enterpriseOrganization:'组织转移',
    queryProxyCheckinData:'Iccid导出',//接入iccid
    agentOrganization:'组织转移',
    organizationStructure :'组织结构',
    orderLog:"订单记录",
    transaction:"交易明细",
    rebate:'返利明细',
    storePricing:'价格控制',
    menuManagement:'菜单管理',
    storeDispatch:'货币分配',
    recharge:'充值',
    CodeError:"验证码错误",
    storeManagement:'货币管理',

    PayLog:"订单支付明细",
    OrderList:"订单管理",
    order:"订单中心",
    orderBuildLog:'换绑记录',//换绑记录
    orderForm:"购买订单",
    targetEnterprise:"目标企业",
    groupNameEmpty:'群组名称不能为空',
    createGroup:'*创建新群组',
    idRules:'id只能是数字',
    fileRules:'只能上传.txt文件',
    toGenerateData:'要生成数据',
    postposition:'后置',
    preposition:'前置',
    aTotalQB:'共需Q币',
    inputData:'输入数据',
    wrongData:'有错误数据',
    qdivide:'Q币划分',
    pleaseEndData:'请输入结束数据',
    pleaseStartData:'请输入开始数据',
    iccidRules:'*只能输入20个数字或字母组成的数据,前16位必须相同,后4位只能是数字',
    onlyNumberOrLetters:'*每一行的数据长度大于等于6,小于等于20,如果数据长度超过10,截取后10位作为账号',
    flagExplain:'*标识数据和起始名称一起使用，前置是放在名称前面，依次递增，例如: 起始名称：张三，标识数据：1，前置，用户名称为：1张三，2张三等',
    onlyNumber:'*只能是数字',
    passwordRules:'*不输入,则为默认密码',
    numberCreationMode:'创号方式',
    establishedGroup:'已建群组',
    newGroup:'新增群组',
    paymentMethod:'缴费方式',
    groupName:'群组名称',
    batchRules:'注: 1，导入Excel支持Q币划分和订单绑定 \n\n 2，Q币的数量以第一条数据Q币数量为准，订单号以第一条数据订单号为准  \n\n 3，具体表格项查看第二页说明书',

    uploadRules:'只能上传.txt文件（记事本），记事本中每一行的数据由20个数字或者字母组成。选择文件上传时， IMEI创建和iccid连号创建不能有数据， 点击上传到服务器直接保存数据',
    dataNoEmpty:'数据不能为空',
    uploadService:'上传到服务器',
    selectFile:'选取上传文件',
    iccidSerial:'iccid连号创建',
    accountStartData:'账号起始数据',
    enterAccountStartData:'请输入账号起始数据',
    enterModelId:'请输入机器型号',
    imei:'IMEI',
    imeiRangeOfNew:'imei区间新增',
    imeiDownloadTemplate:'imei模板下载',
    modelName:'终端机型',
    tmodelName:'硬件机型',
    mgtPswd:'管理员密码',
    smodelName:'软件机型',
    sVer:'软件版本',
    addModel:'添加机型',
    deleteImeiError:'已经绑定用户，不能删除',
    clearEchoData:'清除回显数据',
    noAuthority:'没有权限',
    CheckOutProblem:'校验不通过',
    success:'成功',
    failed:'失败',
    batch:'批次',
    modelId:'机器型号id',
    bindModel:'机型绑定',
    confirmLifeTime:'确定终身绑定',
    UnbindLifeTime:'解除终身绑定',
    BindLifeTime:'绑定终身',
    queryGroup:'群组查询',
    yes:'是',
    no:'否',
    userId:'用户id',
    enterpriseId:'企业id',
    imeiHint:'如果不选批次，导出的是所有的数据',
    flagStartNumber:'标识数据',
    userPassword:'用户密码',
    firstName:'起始名称',
    companyName:'公司名称',
    userNameFlag:'标识位置',
    batchOrder:'订单',
    accountImei:'账号IMEI',
    createAccountImei:'账号imei新增',
    iccidSerialNumber:'iccid连号',
    txtTextUpload:'txt文本上传',
    iccidCreateUser:'区间最多只能生成100个用户',
    accountToBeTransferred:'待转移账号',
    halt:'断网',
    haltSuccess:'断网成功',
    activationSuccessful:'激活成功',
    cardStatus:'卡状态',
    restorationNetwork:'恢复网络',
    restorationNetworkSuccess:'恢复成功',
    trafficQuery:'流量查询',
    accessNumber:'物联网号',
    activate:'激活',
    unbundlingSuccess:'解绑成功',
    bindingSuccess:'绑定成功',
    operator:'运营商',
    binding:'绑定',
    unbundle:'解绑',
    refresh:'刷新',
    ends:"末",
    begin:"始",
    common:"公共数据",
    Rangeofnew:'区间新增',
    iccid:'iccid卡号',
    iccidmanage:'iccid卡管理',
    checkinIccid:'iccid导出',
    zenterprisemanage:'企业管理',
    PleaseSelecTheIccidToDelete:'请选择要删除的iccid',
    Transfer:'账号转移',
    qbMust0 : "请输入大于0的数",
    qbLess :'请输入小于0的数',
    qbRecycling:'Q币回收',
    Digitalpublicnetworkintercom: "公网数字对讲机", //公网数字对讲机
    ModifyMaterial: "修改资料",//修改资料
    ModifyInfo: "修改信息",//修改信息
    Location: "当前位置",//当前位置
    BatchAddGroup: "批量新增",//新增群组
    AlreadyAddGroup: "已添加",//已添加群组
    AlreadyAddUser:"已添加成员",//已添加成员
    WaitAddGroup: "待添加",//待添加群组
    WaitAddUser:"待添加成员",//待添加
    login: "登录",
    Add: "添加",  //添加
    Delete: "删除",// 删除
    signOut: "退出",
    copy:"复制",
    copyAll:"全部复制",
    copySuccess:"复制成功",
    currentGroupName:"当前群组",
    domainName: "域名", //域名
    DomainName: "域名管理", //域名管理
    DomainNameManage: "域名管理", //域名管理
    enterDomainName: "请输入域名",
    BrandManage: "品牌管理", //品牌管理
    model: "机型", //品牌管理
    modelmanage: "机型管理", //品牌管理
    expirationReminder:"到期提醒",//到期提醒
    locationManagement:"位置管理",
    PleaseSetTheUploadTime:"请设置上传位置时间",//请设置上传位置时间
    //请输入域名
    name: "名称",
    accountType: "帐户类型",
    hello: "您好",
    account: "账号",
    imeiAccount:"imei号",
    newAccount:"新账号",
    oldAccount:"旧账号",
    states: "状态",
    phone: "手机",
    money: "金额",//金额
    email: "邮箱",
    eamil: "邮箱",
    password: "密码",
    company: "公司",
    proxy: "代理",
    proxyAccount: "代理账号",
    proxyName: "代理名称",
    subProxyAccount: "子代理账号",
    subProxyName: "子代理名称",
    address: "地址",
    operate: "操作",
    edit: "编辑",
    detail: "详情",
    create: "新增",
    countCompany: "企业数量",
    countTerminal: "用户数量",
    remainQMoney: "Q币",
    query: "查询",
    history: "历史记录", //历史记录
    manage: "Q币分配",
    storeManage: "虚拟货币分配",
    log: "日志",
    normal: "正常",
    Arrears: "欠费",//欠费
    pause: "暂停",
    reset: "重置",
    queryAll:"查所有",
    delete: "删除",
    return: "返回",
    resetpassword: "重置密码",
    allocationPasswordReset: "分配密码重置",
    index: "序号",
    dateTime: "日期",
    TEL: "固话",
    province: "省份",
    city: "城市",
    county: "区县",
    provincecitycounty: "省市区",
    street: "街道",
    remark: "备注",
    register: "注册",
    cancel: "取消",
    save: "保存",
    AgencyManagement: "代理管理",
    ProxyDetail: "代理详情",
    BatchOperation: "批量操作",//批量操作
    Certain: "确定",//确定
    identityCard: "身份证",
    enterYouAccount: "请输入账号",
    enterYouEnterpriseAccount:'请输入企业账号',
    enterYouProxyAccount:'请输入代理账号',
    enterYouMoney: "请输入金额",//请输入金额
    enterYouEmail: "请输入邮箱",
    enterYouPhone: "请输入手机",
    enterYouEamil: "请输入邮箱",
    enterYouTel: "请输入固话:XXXX-XXXXXXX",
    enterYouCompanyName: "请输入公司名称",
    enterYouStates: "请选择状态",
    enterYouDateTime: "请选择日期",
    SelectProvince: "请选择省份",
    SelectCity: "请选择城市 ",
    SelectCounty: "请选择区/县",
    SelectStreet: "请输入街道",
    enterproxy: "请输入代理",
    selectproxy: "请选择代理",
    selectenterprise:"请选择企业",
    enteridentityCard: "请输入身份证",
    enterName: "请输入名称",
    enterICCId: "请输入ICCID",
    enterIMEI:'请输入IMEI',
    enterRemark: "请输入备注",
    enterYouPassWord: "请输入密码",
    reEnter: "再次输入",
    reEnterYouPassWord: "请再次输入密码",
    enterYouVerificationcode: "请输入验证码 ",
    // 以下账号 管理
    AccountManage: "账号管理",
    jurisdiction: "权限",

    AccountType: "类型",
    type: "类型", //操作类型
    createDate: "创建日期",
    modifyDate: "修改日期", //结束时间
    expiredDate: "到期日期", //到期日期
    iccId: "iccId", //iccId
    iccidUser:"扫描新增",
    imeiimportexcel:"IMEI新增",
    imeiinfo:"IMEI查询",
    lifefreeimportexcel:"终身导入",
    messageQuery: "信息查询", //信息查询
    SelectJurisdiction: "请选择",
    PleaseSelect: "请选择",
    //操作记录
    SystemManage: "系统管理",
    OperationRecord: "操作记录", //操作记录
    orderRecord: "订单记录", //订单记录

    OperationType: "类型", //操作类型
    DeleteUser: "删除用户",
    ModifyUser: "修改用户",
    AddGroup: "新增群组",
    ModifyGroup: "修改群组",
    DeleteGroup:"删除群组",
    AddFriend: "新增好友",
    DeleteFriend: "删除好友",
    //自己新增
    AddEnterprise: "新增企业",
    DeleteEnterprise: "删除企业",
    ModifyEnterprise: "修改企业",

    // ----统计信息
    TotalManage: "统计信息", //统计信息
    TotalProxy: "代理总数",  //代理总数
    RegUser: "注册用户",  //注册用户
    UseUser: "Q币使用用户",  //使用用户
    totalUseUser: "总使用用户",  //使用用户
    lifelongUser:'协议用户',
    OnLineUser: "在线用户",  //在线用户
    OneMonthOverdueCount: "欠费1月",//过期一个月数量
    OneWeekOverdueCount: "欠费1周",//过期一个周
    AboutAWeekOverdueCount: "1周后到期",
    AboutAMonthOverdueCount: "1月后到期",//快过期一个月数量
    About3MonthOverdueCount: "3月后到期",//快过期一个月数量
    oneWeekOverdueCountAdd:"欠费1月+",//欠费一个月以上
    OneMonthOverdueCountQB: "Q币欠费1月",//过期一个月数量
    OneWeekOverdueCountQB: "Q币欠费1周",//过期一个周
    AboutAWeekOverdueCountQB: "Q币1周后到期",
    AboutAMonthOverdueCountQB: "Q币1月后到期",//快过期一个月数量
    oneWeekOverdueCountAddQB:"Q币欠费1月+",//欠费一个月以上
    //特殊播报
    BroadCast: "特殊播报",
    Matter: "内容",
    ENterMatter: "请输入内容",
    //Q币
    RechargeValueQ: "Q币充值", //Q币充值
    RechargeValueMoney: "充值金额", //充值金额
    OldPassWord: "旧密码", //旧密码
    NewPassWord: "新密码", //新密码
    PWD: "密码", //密码
    EnterMoney: "请输入金额", //请输入金额
    QManage: "Q币管理", //Q币管理
    QDistribution: "Q币分配",

    CurrBalance: "当前余额", //当前余额
    CurrentBalanceDeficiency: "当前余额不足", //当前余额不足
    setting: "设置", //设置
    //Q币日记
    QLog: "Q币日志",
    DealQ: "交易Q币数", //交易Q币数
    DealDate: "交易时间", //交易时间
    Operator: "操作人",//操作人
    User: "用户",//用户
    EPAccount: "企业账号", //企业账号
    EPName:"企业名称",
    TerminalAccount:"终端账号",
    TerminalName:"终端名称",
    //Q币交易记录
    DealRecord: "交易记录", //交易记录
    Place: "划分", //划分
    Recover: "回收", //回收
    QNumber: "Q币", //Q币数
    Export: "导出", //导出
    //Q币管理
    CurrProxyRemainQ: "{type, select ,1{当前总代余额Q币} 2{当前代理余额Q币} other{}} ",   //当前总代余额Q币
    CurrMerchantRemainQ: "当前代理余额Q币",//当前代理余额Q币
    TargetProxyRemainQ: "{type, select ,1{目标代理余额Q币} 2{目标子代理余额Q币} other{}} ",   //当前总代余额Q币
    TargetEnterpRemainQ: "目标企业余额Q币",//目标企业余额Q币
    Explain: "说明",//说明
    PlaceRecoverQ: "{type,select,1{划分Q币} 2{回收Q币} other{划分/回收Q币}} ",//划分/回收Q币
    PlaceExplain: "{role,select,1{划分:把Q币分配给代理} 2{划分:把Q币分配给子代理} 5{划分:把Q币分配给代理}  8{划分:把Q币分配给子代理}other{}} ",//划分/回收Q币
    EnterQNumber: "请输入Q币数",//请输入Q币数
    // PlaceExplain: "划分:把Q币分配给代理",//划分:把Q币分配给代理
    PlaceExplains:"划分:把Q币分配给子代理",
    // RecoverExplain: "回收：把分出去的Q币从代理收回",//回收：把分出去的Q币从代理收回
    RecoverExplain: "{role,select,1{回收：把分出去的Q币从代理收回} 2{回收：把分出去的Q币从子代理收回} 5{回收：把分出去的Q币从代理收回}  8{回收：把分出去的Q币从子代理收回}other{}} ",//划分/回收Q币
    RecoverExplainV: "{role,select,1{回收：把分出去的货币从代理收回} 2{回收：把分出去的货币从子代理收回} 5{回收：把分出去的货币从代理收回}  8{回收：把分出去的货币从子代理收回}other{}} ",//划分/回收货币

    //子代理统计
    TotalChildProxy: "子代理总数", //子代理总数
    TotalEnterprise: "企业总数", //企业总数
    //子代理管理
    SubagentManagement: "子代理管理",//子代理管理
    //企业管理
    EnterpriseManage: "企业管理",//代理--企业管理
    SECENTERPRISEMANAGE: "企业管理",//子代理--企业管理
    UserNumber: "用户数量",//用户数量
    EnterpriseDetail: "企业详情",//企业详情
    //子代理详情
    SecMerchangDetail: "子代理详情",//子代理详情/
    funs: "功能",//功能
    userFuns: "用户功能",//用户功能
    SingleCall: "单呼",//单呼
    Position: "定位",//定位
    Friend: "好友",//好友
    Record: "录音",//录音
    //---二级管理
    SecEnterprise: "二级管理", //二级管理
    //群组管理
    Group: "群组",//群组
    CurGroup: "当前群组",//群组
    GroupFuns: "二级群组",//群组功能 改为 二级群组
    GroupType: "群组类型",//群组类型
    GroupManage: "群组管理",//群组管理
    NormalGroup: "普通群",//普通群
    TemporaryGroup: "临时群",//临时群
    NestingGroup: "嵌套群",//嵌套群
    //代理  Q币管理
    SecPlaceExplain: "划分:把Q币分配给企业",//划分:把Q币分配给企业
    SecRecoverExplain: "回收：把分出去的Q币从企业收回",//回收：把分出去的Q币从企业收回
    //企业的账号管理
    UserManage: "用户管理",//用户管理
    usermanage: "用户管理",//用户管理
    //企业--统计信息
    TotalGroup: "群组总数",//群组总数

    //用户管理
    onLine: "在线",//在线
    Thisaccountalreadyexistspleaseenteragain: "该账号已存在，请重新输入",// 该账号已存在，请重新输入
    Pleaseenteragainbeforeandafteraccountnumber: "前后账号一致，请重新输入",// 前后账号一致，请重新输入
    UserDetail: "用户详情",//用户详情
    friendmanage: "好友",//好友管理
    TalkLevel: "通话等级",//通话等级
    RechargeValue: "充值",//充值
    WaitAddFriend: "待添加好友",//待添加好友
    AlreadyAddFriend: "已添加好友",//已添加好友
    CurrSecEnterprise: "当前二级管理",//当前二级管理
    CancelSecEnterprise: "取消二级管理",//取消二级管理
    PleaseSelectAdvocateSearch: "请选择,支持搜索", //请选择,支持搜索
    AddUser: "新增用户",//新增用户
    QUANSHENGGONGSI: "福建泉盛电子有限公司",//福建泉盛电子有限公司
    ModifyStatus: "修改状态",  //修改状态
    Low: "低",//低
    Middle: "中",//中
    High: "高",//高
    ExtraHigh: "特高",//特高
    BatchImport: "批量新增",//导入与导出/
    Import: "导入",//导入
    downloadtemplate: "下载模板",// 下载模板
    //Q币分配
    DivisionQ: "Q币分配",//Q币分配
    EnterpriseWaitQ: "企业待分配Q币",//企业待分配Q币
    EnterpriseAlreadyQ: "企业已分配Q币",//企业已分配Q币
    //百度地图
    start: "开始",//开始
    stop: "停止",//停止
    UserPosition: "定位", //用户定位
    //录音管理
    RecordingManagement: "录音管理", //录音管理
    BatchPlay: "批量播放",//批量播放
    BatchDownload:"批量下载",//批量下载
    Play: "播放",//播放
    BatchDel: "批量删除",//批量删除

    Timing: "时长", //时长
    //档案数据
    FilesData: "档案数据",//档案数据
    lengths:"不满足：公共数据+始 或 公共数据+末 长度为20的条件",
    SaveAndModifySuccess: "新增/保存成功 ！",// 新增/保存成功！
    DeleteSuccess: "删除成功 !",//删除成功
    OperateSuccess: "启用成功 ！",//启用成功！
    PauseSuccess: "暂停成功 !",//暂停成功！
    SwitchSuccess: "切换成功 ！",//切换成功
    ResetSuccess: "重置成功 !",//重置成功！
    Hint: "提示",//提示
    NormalStateCannotDeletePleaseStopFirst: "正常状态，无法删除！请先停用 !",//正常状态，无法删除！请先停用
    DomainNameAndUserIdAndMerchantLevel: "请选择用户或域名 !",//请选择用户或域名
    PauseStateCannotBeUsedPleaseEnableFirst: "暂停状态，无法使用！请先启用 !",//暂停状态，无法使用！请先启用

    ConfirmDeletingThisUser: "确认删除该用户吗 ?",//确认删除该用户吗
    ConfirmDeletingThisIccid:"确认删除该iccid卡号吗？",
    ConfirmSelectThisDomainName: "确认选择该域名吗 ?",//确认选择该域名吗
    ConfirmDeletingThisFile: "确认删除该文件吗 ?",//确认删除该文件吗
    ConfirmEnablingThisUser: "确认启用该用户吗 ?",//确认启用该用户吗
    ConfirmSuspendingThisUser: "确认暂停该用户吗 ?",// 确认暂停该用户吗
    ConfirmThatThisUserPasswordIsResetTo: "是否将该用户密码重置为默认密码 ",// 确认将该用户密码重置为123456吗
    Cttuapirt:"是否将用户分配密码重置为默认密码",//Confirm that the user assigned password is reset to 123456
    ConfirmLifetimeBindState:'确认改为终身绑定状态',//Whether to change the lifetime binding state
    ConfirmLifetimeUnboundState:'确认解除终身绑定状态',//"Confirm that the lifetime binding is unbound"
    RelieveSuccess:'解除成功',//
    BindSuccess:'绑定成功',
    Create: "新增",//新增
    Modify: "修改",//修改
    DetermineIfYouWantToExport: "确定要导出 ?",//确定要导出
    LastWeek: "最近一周",//最近一周
    LastMonth: "最近一个月",//最近一个月
    LastThreeMonths: "最近三个月",//最近三个月
    LastHalfYear: "最近半年",//最近半年
    LastOneYear: "最近一年",//最近一年
    LastThreeYear: "最近一年",//最近一年
    PleaseSelectRecordingToOperate: "请选择要操作的录音 !",//请选择要操作的录音
    PlayEnd: "播放结束",//播放结束

    ConfirmDeletingThisGroup: "确认删除该群组吗 ?",//确认删除该群组吗
    ConfirmEnablingThisGroup: "确认启用该群组吗 ?",//确认启用该群组吗
    ConfirmSuspendingThisGroup: "确认暂停该群组吗 ?",// 确认暂停该群组吗

    PleaseSelectData: "请选择数据 !",// 请选择数据
    CanAllocateQMoneyInsufficientOperationFailed: "可分配Q币不足！操作失败 !",//可分配Q币不足！操作失败！
    Implementation: "执行中...",//执行中...
    SuccessfulOperation: "操作成功 !",// 操作成功
    FailureOperation:"操作失败！",//操作失败
    ConfirmExportingThisRecord: "确认导出该记录吗 ?",//确认导出该记录吗
    PleaseEnterANumberOfCoins: "请输入Q币数 !",//请输入Q币数
    PleaseEnterANumberOfCoinsLargerThan0: "请输入大于0的Q币数 !",//请输入大于0的Q币数
    PleaseSearchTargetChildAgentFirst: "请先搜索目标子代理 !",// 请先搜索目标子代理
    PleaseSearchTargetAgentFirst: "请先搜索目标!",// 请先搜索目标代理
    CurrentSubAgentBalanceIsInsufficientPleaseReEnter: "当前子代理余额不足，请重新输入",//当前子代理余额不足，请重新输入
    CurrentAgentBalanceIsInsufficientPleaseReEnter: "目前代理余额不足，请重新输入",//目前代理余额不足，请重新输入
    CurrentEnterpriseBalanceIsInsufficientPleaseReEnter: "目标企业余额不足，请重新输入",//目前代理余额不足，请重新输入
    PlaceSuccess: "划分成功!",// 划分成功
    PlaceTotal: "划分统计",// 划分统计
    RecoverSuccess: "回收成功!",//回收成功
    RecoverTotal: "回收统计",//回收统计
    BalanceCannotBeLessThan1CannotBeRecoveredPleaseReEnter: "余额不能小于1，无法回收，请重新输入",// 余额不能小于1，无法回收，请重新输入
    CurrentlyInsufficientBalanceOfSubAgentPleaseReEnter: "目前子代理余额不足，请重新输入",//目前子代理余额不足，请重新输入
    PasswordError: "密码错误!",// 密码错误
    ConsistentPasswordBetweenOldAndNew: "新旧密码一致",//新旧密码一致
    PleaseEnterEnterpriseAccountQueryFirst: "请先输入企业账号查询 !",//请先输入企业账号查询
    PleaseEnterEnterprise: "请先选择企业!",//请先选择企业

    ConfirmDeletingThisSecEnterprise: "确认删除该二级管理吗 ?",//确认删除该二级管理吗
    ConfirmEnablingThisSecEnterprise: "确认启用该二级管理吗 ?",//确认启用该二级管理吗
    ConfirmSuspendingThisSecEnterprise: "确认暂停该二级管理吗 ?",// 确认暂停该二级管理吗

    ConfirmEnablingThisTerminal: "确认启动该终端吗 ?",//确认启用该终端么？
    ConfirmSuspendingThisTerminal: "确认暂停该终端吗 ?",//确认暂停该终端么？

    ConfirmDeletingThisSecAgent: "确认删除该子代理吗 ?",//确认删除该子代理吗
    ConfirmEnablingThisSecAgent: "确认启用该子代理吗 ?",//确认启用该子代理吗
    ConfirmSuspendingThisSecAgent: "确认暂停该子代理吗 ?",// 确认暂停该子代理吗

    ConfirmDeletingThisBoardCast: "确认删除该播报吗 ?",//确认删除该播报吗
    ConfirmEnablingThisBoardCast: "确认启用该播报吗 ?",//确认启用该播报吗
    ConfirmSuspendingThisBoardCast: "确认暂停该播报吗 ?",// 确认暂停该播报吗

    ConfirmDownloadTemplate: "确认下载模板吗 ?",//确认下载模板吗
    IsOnline: "在线状态",//是否在线
    OnlineStatus: [
      { id: "0", name: "在线",code:true },
      { id: "1", name: "离线",code:false }
    ],
    simpleOrFullColumn: [
      { id: "0", name: "精简数据列",code:false },
      { id: "1", name: "完整数据列",code:true }
    ],

    //登录
    Error: "错误",//错误
    PleaseCompleteTheVerification: "请完成验证！",//请完成验证
    CodeCannotBeEmpty: "验证码不能为空",// 验证码不能为空
    ThisAccountHasBeenSuspendedPleaseHandle: "该账号已暂停，请处理 !",//该账号已暂停，请处理！
    AccountOrPasswordError: "账号密码或域名错误! ",//账号密码错误
    //---------------------
    //终端管理
    TerminalManage: "终端管理",//终端管理
    TerminalEvent: "终端操作",//终端操作
    EnterPrise: "企业",//企业
    help: "帮助",
    MenuManage: "菜单管理",
    SettingDistributionPassword: "分配密码",//QB分配密码
    SetDistributionPaw: "分配密码",//QB分配密码
    SIMManagement: "SIM卡管理",
    //步骤条 多语言
    stepOne: "第一步",
    stepTwo: "第二步",
    stepSuceess: "完成",
    stepNext: "下一步",
    //步骤条提示语
    PleaseEnterTheOldAssignedPassword: "请输入旧的分配密码!",
    PleaseEnterTheNewAssignedPassword: "请输入新的分配密码!",
    confirmPassword: "确认密码",


    //数据统计
    increaseCount:'增长统计',
    onlinenumber:'在线数量',
    DataTotal: "数据统计", //数据统计
    MonthDataTotal: "月份统计", //月份数据统计
    ExAndEarTotal: "收支统计", //收支统计
    Earning: "充值",//充值
    Expenditure: "消耗",//支出
    AnnualBalanceOfPayments: "年度收支表",//年度收支表
    YearDataTotal: "年度统计",//年度统计
    RepAndPlaTotal: "划回统计",//划回统计
    //会计管理
    AccountantManage: "会计管理", //会计管理
    //会计操作记录
    AccountantEvent: "会计操作记录",//会计操作记录
    accountUser: "账号用户",
    iccIdUser: "ICCID用户",
    offset: "偏移量",
    Unbundled: "解绑",
    Bind: "绑定",
    //企业激活统计
    EPActivateTotal: "激活统计", //激活统计
    EP_EPActivateTotal: "激活统计", //激活统计
    GA_EPActivateTotal: "激活统计", //激活统计
    UnitStation: "单位/台", //单位/台
    Year: "年份", //年份
    Jan: "一月", //一月
    Feb: "二月", //二月
    Mar: "三月", //三月
    Apr: "四月", //四月
    May: "五月", //五月
    Jun: "六月", //六月
    Jul: "七月", //七月
    Aug: "八月", //八月
    Sep: "九月", //九月
    Oct: "十月", //十月
    Nov: "十一月", //十一月
    Dec: "十二月", //十二月
    //消息管理
    Message: "消息管理",//消息管理
    Poop: "消息",//消息
    TerminalMessage: "终端消息",//终端消息
    ConfirmDeletingThisMessage: "确认删除该消息吗 ?",//确认删除该消息吗
    domainLibrary: "域名库",
    isNull: "暂无",
    userInfo: "用户信息",
    currentDomain: "当前域名",
    seletcDomain: "选择域名",

    groupmanage:'群组管理',
    groupfunc:'群组功能',
    groupInfo:'群组信息',
    membermgt:'成员管理',

    //终端事件
    MODEL_OF_DEFAULT : "默认事件",
    MODEL_OF_LOGIN : "登录事件",
    MODEL_OF_HEARTBEAT : "心跳包事件",
    MODEL_OF_RESPONSE : "回复推送消息事件",
    MODEL_OF_UNKNOW_DEVICE : "未知设备类型事件",
    MODEL_OF_LOGOUT : "登出事件",
    MODEL_OF_REMOTE_FORCEDOWN : "设备强制下线事件",
    MODEL_OF_MUTEXDOWN : "挤下线事件",
    MODEL_OF_LOCAL_FORCEDOWN : "服务器强制下线事件",
    MODEL_OF_HEARTBEAT_TIMEOUT : "心跳超时",
    MODEL_OF_EXCEPTION : "异常事件",
    MODEL_OF_PROTOCOLFAULT : "协议解析处理故障",

},

  relevance:{
    groupName1:"群组名称",
    groupName2:"群组名称2",
    pleaseEnterGroupName:"请输入群组名称",
    pleaseEnterGroupName2:"请输入群组2名称",
    groupId1:"群组ID",
    groupId2:"群组ID2",
    pleaseEnterGroupId1:"请输入群组id",
    pleaseEnterGroupId2:"请输入群组id2",
    groupListen1:"群组1听",
    groupListen2:"群组2听",
    updateSuccessfully:"更新成功",
    saveSuccessfully:"保存成功",
    pleaseSelectGroup:"请选择群组",
    pleaseSelect:"请选择",
    query:"查询",
    hint:"选择群组后需要点击查询按钮,再进行关联",
    groupAssociated:"待关联群组",
    associatedGroup:"关联群组",
    onlyOneGroup:"一次只能关联一个群组",
    onlyChangeOne:"只能选择一个进行删除",
  },

  button: {
    create: "创建",
    createOrder:'创建订单',
    add: "新增",
    update: "更新",
    cancel: "取消",
    search: "查询",
    reset: "重置",
    edit: "编辑",
    submit:'提交',
    remove:'删除',
    restore:'恢复',
    member:'成员',
    group:'成员管理',
    oneClickLogin:'一键登录',
    confirmImport:'确定导入',
    sync:'同步',
    accessSync:'接入同步',
    qbLogger:'Q币日志',
    tradeLog:'交易日志',
    bind:"绑定",//绑定
    sure:"确 定",//确定
    expiringOrders:"查询即将到期订单",//查询即将到期订单
    featuresAndRenewals:"增加功能及续签",//增加功能及续签
    rebook:"改签",//改签
    activation:"激活",//激活
    orderDetails:"订单详情",//订单详情
    batchTermination:"批量终止",//
    batchFunction:"批量功能",
    batchOrder:"批量订单",
    batchQB:"批量QB",
    batchSecondary:"批量二级",
    batchSetting:"批量设置",
    unbind:"一键解绑",
    binding:"一键绑定",
    divide:"一键划分",
    recycle:"一键回收",
  },
  form: {
    label: {
      name:'名称:',
      pass: "密码:",
      account: "账号:",
      status:'状态:',
      phone:'手机号:',
      checkPass: "确认密码:",
      remark:'备注',
      group: {
        name: "群组名称:",
        type: "群组类型:"
      },
      groupId:"群组Id",
      id:'Id',
      orderId:"订单号",
      orderDuration:"订单时长",// 订单时长
      remainingTime:"剩余时长",//剩余时长
      payerAccount:"付款人账号",//付款人账号
      payerName:"付款人名称",//付款人名称
      balanceBeforePurchase:"购买前余额",//购买前余额
      balanceAfterPurchase:"购买后余额",//购买后余额
      substitutePayerAccount:"代付人账号",//代付人账号
      substitutePayerName:"代付人名称",//代付人名称
      balanceBeforeSubstitute:"代付前余额",//代付前余额
      balanceAfterSubstitute:"代付后余额",//代付后余额
      functionName:"功能名",//功能名
      unitPrice:"单价",//单价
      listPrice:"标价", //标价
      number:"个数",//个数
      durationType:"时长类型",//时长类型
      duration:"时长" ,//时长
      storageTime:"存储时长",//存储时长
      payerPrice:"支付价格",//支付价格
      ownerAccount:"所属者账号",//所属者账号
      featureSelection:"功能选择",//功能选择
      terminalFunctionCoverage:"终端功能覆盖",//终端功能覆盖
      totalNumberOfOrderAccounts:"订单账号总数",// 订单账号总数
      numberOfRemainingAccounts:"剩余账号数",//剩余账号数
      numberOfActivatedAccounts:"激活账号数",//激活账号数
      numberOfAccounts:"账号数",//账号数
      paidFeatures:"付费功能",//付费功能
      recordingStorageTime:"录音保存时长",//录音保存时长
      trackSaveTime:"轨迹保存时长 ",//轨迹保存时长
      activeState:"激活状态", //激活状态
      ChangeNumberOfAccounts:" 改签账号数",//改签账号数
      F2F:'面对面建群',
      affiliatedCom:"所属企业",//所属企业
      targetBusiAccount:"目标企业账号",//目标企业账号
      renewalPeriod:"续签时长",//续签时长
      recordingSaveTime:"录音保存时间",//录音保存时间
      locationSaveTime:"定位保存时间",//定位保存时间
      createDate:"创建时间",//创建时间
      startDate:"启用日期",//启用日期
      dateOfExpiry:"到期日期",//到期日期
      totalOrderDuration:"订单总时长",//订单总时长
      bindUser:"绑定用户",//绑定用户
      beforeTalkie:"改前对讲价格",//改前对讲价格
      afterTalkie:"改后对讲价格",//改后对讲价格
      beforeDispatch:"改前调度价格",//改前调度价格
      afterDispatch:"改后调度价格",//改后调度价格
      beforeRecord:"改前录音存储一个月",//改前录音存储一个月
      afterRecord:"改后录音存储一个月",//改后录音存储一个月
      beforeRecord1:"改前录音存储三个月",//改前录音存储三个月
      afterRecord1:"改后录音存储三个月",//改后录音存储三个月
      beforeRecord2:"改前录音存储六个月",//改前录音存储六个月
      afterRecord2:"改后录音存储六个月",//改后录音存储六个月
      beforeRecord3:"改前录音存储一年",//改前录音存储一年
      afterRecord3:"改后录音存储一年",//改后录音存储一年
      beforeLocation:"改前定位存储7天",//改前定位存储7天
      afterLocation:"改后定位存储7天",//改后定位存储7天
      beforeLocation1:"改前定位存储一个月",//改前定位存储一个月
      afterLocation1:"改后定位存储一个月",//改后定位存储一个月
      beforeLocation2:"改前定位存储三个月",//改前定位存储三个月
      afterLocation2:"改后定位存储三个月",//改后定位存储三个月
      beforeLocation3:"改前定位存储六个月",//改前定位存储六个月
      afterLocation3:"改后定位存储六个月",//改后定位存储六个月
      beforeLocation4:"改前定位存储一年",//改前定位存储一年
      afterLocation4:"改后定位存储一年",//改后定位存储一年
      beforeBroadcast:"改前广播价格",//改前广播价格
      afterBroadcast:"改后广播价格",//改后广播价格
      talkie:"对讲",//对讲
      dispatch:"调度",//调度
      record:"录音存储1个月",//录音存储1个月
      record1:"录音存储3个月",//录音存储3个月
      record2:"录音存储6个月",//录音存储6个月
      record3:"录音存储一年",//录音存储一年
      location:"定位存储7天",//定位存储7天
      location1:"定位存储1个月",//定位存储1个月
      location2:"定位存储3个月",//定位存储3个月
      location3:"定位存储6个月",//定位存储6个月
      location4:"定位存储一年",//定位存储一年
      broadcast:"广播",//广播
      purchaseQuantity:"购买数量",//购买数量
      rebateAmount:"返利金额",//返利金额
      orderType:"订单类型",//订单类型
      pricing:"定价",//定价
      operatorAccount:"操作人账号",//操作人账号
      operatorName:"操作人名称",//操作人名称
      operatorRole:"操作人角色",//操作人角色
      transactionAmount:"交易金额",//交易金额
      originAccount:"来源人账号",//来源人账号
      originName:"来源人名称",//来源人名称
      originRole:"来源人角色",//来源人角色
      originBeforeBalance:"来源人操作前余额",//来源人操作前余额
      originAfterBalance:"来源人操作后余额",//来源人操作后余额
      targetAccount:"目标人账号",//目标人账号
      targetName:"目标人名称",//目标人名称
      targetRole:"目标人角色",//目标人角色
      targetBeforeBalance:"目标人操作前余额",//目标人操作前余额
      targetAfterBalance:"目标人操作后余额",//目标人操作后余额














    }
  },

  file,
  excel:{
    import: "导入Excel",
    export: "导出Excel"
  },
  zip: {
    download: {
      template: "下载模板"
    }
  },

  validate: {
    size: {
      domainName: "长度在 2 到 500 个字符",
      name:'长度在 2 到 10 个字符',
      modelName:'长度在 2 到 50 个字符',
      modeName:'长度在 2 到 12 个字符',
      account:'长度在6-16字符',
      password:'长度在 6 到 15个字符',
      iccid:'长度16或者20个字符',
      begin:'长度为1-3个数字',
      common:'长度为17 到 19个字符',
      flagData:'只能输入数字,长度不能超过6位数',
      startData: '长度16或者20个字符',
      endData: '长度16或者20个字符',
      imeicommon:'长度为9到12个数字',
      imeistart:'长度为2到5个数字',
      imeiend:'长度为2到5个数字',
      startAccount:'长度为1位数字或小写字母',
      remark:'长度应小于200个字符',
      imei:'长度为15个数字',
      isManufa:'长度为6-16个数字,',
      isAgreementId:'长度为6-16个字符或数字,',
      isPort:'长度为0-6个数字',
      isIp:'请输入合法ip (x.x.x.x)',
      verifyValue:'长度为2-25个字符',
      isNotNUll:'数据不能为空!',
      order:'只能输入数字',
    },
    warning:{
      // string:'',
      name:'请输入名称，只能包含中文、英文、数字、下划线等字符',
      domainName: '请输入合法域名，只能包含中文、英文、数字、下划线等字符',
      account:'请输入合法账号，只能包含英文、数字、下划线等字符',
      accountHasBeenUsed:'账号已经被使用',
      iccidHasBeenUsed:'iccid号已被使用',
      enterpriseIccid:'iccid账号不属于总代',
      password: '请输入合法密码，长度在6-16之间，只能包含字符、数字和下划线',
      iccid:'请输入合法iccid号，长度为20个字符串,' ,//以8986(00,01,02,03,07)开头'
      begin:'请输入始数据，长度在1-3之间',
      end:'请输入末数据，长度在1-3之间',
      common:'长度为17 到 19个字符以8986(00,01,02,03,07)开头',
      imeicommon:'公共部分长度为9-12个数字',
      imeistart:'起始长度为2-5个数字',
      imeiend:'结束长度为2-5个数字',
      imei:'imei长度为15个数字',
      startAccount:'长度为1个数字或者小写字母',
      flagData:'只能输入数字，长度不超过6位数',
      startData:'请输入合法iccid号，长度为20个字符串,',
      endData:'请输入合法iccid号，长度为20个字符串,',
      isManufa:'长度为6-16个数字,',
      isAgreementId:'长度为6-16个字符或数字',
      isPort:'长度为0-6个数字',
      isIp:'请输入合法ip (x.x.x.x)',
      verifyValue:'长度为2-25个字符',
      order:'只能输入数字',
      checkPass:[
        '请再次输入密码!',
        '两次输入密码不一致!',
        '两次输入的密码不能一致！'
      ],
      money:'请输入金额!',
      phone:'请填写正确的手机号',
      telPhone:'请输入正确固定电话！',
      email:'邮箱格式不对!',
      identification:'请输入合法身份证号码',
      isNotNUll:'数据不能为空!',
      excelExoprt:{
        name:'名称格式不对,长度 2- 10字符 （必填）',
        account:'账号格式不对 ,不能有中文长度 6- 16字符（必填）',
        password:'密码格式不对 ,长度 6- 15字符（必填)',
        phone:'手机格式不对（选填)',
        identification:'身份证格式不对（选填）',
        callLevel:'通话等级格式错误',
        groupType:'群组类型错误',
        funcs:'功能格式错误',
        iccid:'iccid卡格式不符合，长度为20个字符',
        imei:'imei格式不符合，长度为15个数字',
        startAccount:'账号起始数据格式不符合，为空或者长度为1个数字小写字母',
        isManufa:'长度为6-16个数字,',
        agreementId:'长度为6-16个字符或数字',
        isPort:'长度为0-6个数字',
        isIp:'请输入合法ip (x.x.x.x)',
        qb:'Q币数量只能是数字，且大于等于0，小于等于10',
        order:'订单号只能为数字',
      }
    },
  },

  organizationInfo:{
    addGroup:"添加群",
    currentOrganization:'当前组织',
    groupName:'群组名称',
    account:'账号',
    name:'名称',
    failed:'失败',
    correspondingOrganization:'请选择对应的组织',
    secManagement:'二级管理',
    member:'成员',
    group:'群组',
    saveSuccess:'保存成功',
    add:'添加',
    delete:'删除',
    addOrganization:'添加组织',
    cancel:'取消',
    save:'保存',
    organizationInfo:'组织信息',
    organizationName:'组织名称',
    membershipInformation:'成员信息',
    ourGroup:'本组',
    subunit:'子组',
    ourGroupMembers:'本组成员',
    deleteUser:'删除用户',
    authorityManagement:'权限管理',
    schedulingPermissions:'调度权限',
    groupPermission:'群组权限',
    radioAccess:'广播权限',
    affirm:'确认',
    cancelPermissions:'权限权限',
    childGroup:'子组成员',
    newAdd:'新增',
    organizationTransfer:'组织转移',
    membersMobile:'移动成员',
    organization:'当前组织',
    tenOrganizations:'最多只能创建10个组织层级',
    selectOrganization:'请选择目标组织',
    selectUser:'请选择用户',
    transferSuccess:'转移成功',
    transferAgent:'组织转移',
    moveEnterprise:'要转移企业',
    pleaseChoose:'请选择',
    organizeUser:'组织用户',
    transferEnterprise:'转移到企业',
    confirmTransfer:'确认转移',
    enterpriseCannotTransferred:'同企业不能转移',
    groupUser:'群组成员信息',
    groupInfo:'群组信息',
    hierarchy:'权限层级',
    function:'功能',
  },

  patrolDictionaries:{
    patrolPointName:"巡更点名称",
    validationalue:"验证值",
    name:"名称",
    type:"类型",
    create:"新增",
    remark:"备注",
    lat:"纬度",
    lon:"经度",
    distance:"距离",
    events:"事件",
    edit:"编辑",
    delete:"删除",
    patrolSignIn:"巡更签到",
    yes:"是",
    no:"否",
    pst:"请选择类型",
    scope:"范围",
    defaultMeters:"（单位默认为：米）",//The default unit is meters
    iDCard:"卡id",
    addResult:"添加结果",
    dispatcherWarning:"调度台警告",
    cancelWarning:"取消警告",
    save:"保存",
    cancel:"取消",
  },

  checkbox: {
    createTime: "创建时间",
    enableTime: "开始时间",
    maturityTime: "到期时间",
    modifyTime: "修改时间",
    operator:'操作人',
    origin:'来源人',
    target:'目标人',
    operationRole:'操作人角色',
    originRole:'来源角色',
    targetRole:'目标角色',
    selectAll:"全选",//全选
  },
  loading: {
    option:{
      text:'数据加载中...'
    },
    text: {
      table: "请稍候..."
    }
  },
  error:{
    proxy:{
      fetch:{
        option:'fetch proxy fail'
      }
    },
    enterprise:{
      fetch:{
        option:'fetch enterprise fail'
      }
    }
  },
  prompt:{
    prompt:'提示',
    confirmButtonText:'确定',
    cancelButtonText:'取消',
    assignPassword:{
      title:'请输入分配密码',
      errorMsg:'密码不能为空！'
    },
    oneClickLogin:"是否一键登录该企业？",
    import:"是否导入该数据？",
  },
  notify:{
    title:{
      login:'登录通知',
      orderBind:"订单绑定",//订单绑定
      success:"成功提示",
    },
    lastLogin: '尊敬的用户，您上次登录时间为: {time}, 登录的IP地址为: {ip}',
    search:{
      enterprise:'请先输入企业账号查询',
    },
    cancel:"取消",
    message:{
      bindingSucceeded:" 绑定成功",//绑定成功
      transactionComplete:"交易完成",//交易完成


    },
  },
  operating:{
    success:{
      default:"操作成功!",
      sync:"同步成功",
    },
    error:{
      sync:"正在同步中",
      default:"操作失败!",
      password:'密码错误',
      exportExcel:{
        template:'请使用对应的模板!',
        length:'每次最多只能导入50条！',
        size:'最多只能导入100个终身免费用户!',
        throwMessageByUser:{
          account:'账号必填',
          iccid:'iccid必填',
          imei:'imei必填',
          common:'账号：{account} , @:operating.error.exportExcel.select 必填',
          modelName:'机型必填',
        },
        throwMessageByGroup:' 名称:{name} 必填',
        select:'{type,select,account{账号} password{密码} name{名称} other{}}'
      },

    },
    warning:{
      capitalLimit:"账号:{account}，Q币已经上限！"
    },
    message:{
      insufficientBalance:'@:operating.error.default 剩余Q币不足',
      language:"转换成功！"
    },

  },
  msgbox:{
    title:{

    },
    message:{
      accountTransfer:[
        '转移目标企业为:',
        '',
        '转移账户个数:',
        '个',
      ],

      balanceAssignResult:[
        '此次操作共分配:',
        'Q币',
        '共调整账户个数:',
        '个',
      ]
    }
  },
  unit:{
    //不知道 单位 个 单词是啥玩意
    ge:'个'
  },
  word:{
    name:'名称',
    download:'下载',
    account:'账号',
    group:'群组',
    subagen:'子代理',
    proxy:'代理',
    enterprise:'企业',
    terminal:'终端',
    iccid:'iccid号',
    imei: 'imei号',
    domain:'域名',
  },
  transfer: {
    placeholder:{
      user:'请输入用户名'
    },
    buttonText: [
      "删除",
      "添加"
    ],
    title: {
      user: [
        '待添加用户',
        '已添加用户'
      ]
    }
  },
  dialog:{
    title:{
      modify:'修改',
      add:'新增',
      friendMGT:'好友管理',
      groupMGT:'群组管理',
      SecEnterprise: "二级管理", //二级管理
      orderBind:"订单绑定",//订单绑定
      purchaseOrder:"购买订单",//购买订单
      userBind:"用户绑定",//用户绑定
      orderSplit:"订单拆分",//订单拆分
      orderActive:"订单激活",//订单激活
      orderDetails:"订单详情",//订单详情
      orderPaymentDetails:"订单支付详情",//订单支付详情
      batchFunction:"批量功能设置",//批量功能设置
      bulkOrderSetup:"批量订单设置",//批量订单设置
      batchQbSettings:"批量QB设置",//批量QB设置
    }
  },
  imei: {
    table:{
      imei:"imei",
      modelName:"机器型号",
      account:"账号",
      userId:"用户id",
      createDate:"创建时间",
      batch:"批次号",
      entId:"企业id",
      entAccount:"企业账号",
      entName:"企业名称",
      proxyAccount:"代理账号",
      proxyName:"代理名称",
      subAccount:"子代账号",
      subName:"子代名称",
      change:"请选择要导出的列",
      iccid:"ICCID",
    }
  },
  imeimessage: {
      warn:"注: ",
      modelIsNotNull: "机器型号不能为空",
      dataCheck:"公共数据＋结束数据的长度 = 14",
      length:"末数据不能小于始数据",
      excelWarn:"excel导入,imei必须为15数字.excel中的账号起始列,数据不填默认为:b ",
      imeiWarn:"IMEI区间导入,机器型号必选,公共数据 + 始 = 14 且 公共数据 + 末 = 14 账号起始数据不填默认为: b",
      imeiLength:"imei长度等于 = 14(输入) + 1(系统算出校验位)",
  },
  alert:{
    head:{
      orderReminder:"订单提示",//订单提示
    },
    title:{
      LoginDispatcherRequirements:"登录调度台要求：1 订单购买绑定调度功能，2 功能设置添加调度，3 组织管理设置调度权限等级",
      selectUserBindingOrder:"选择用户绑定订单，对已绑定订单的用户再次选择可以更新用户订单关系！",
      pleaseCheckIf:"请检查订单是否到期或者新增功能!",    //请检查订单是否到期或者新增功能

    },
    closeText:{
      know:"知道了",
    }

  },
  switch:{
    active:{
      cover:"覆盖",//覆盖
    },
    inactive:{
      notCovered:"不覆盖",//不覆盖
    }
  },
  tab:{
    label:{
      defaultOrder:"默认订单",//默认订单
      qbIntercomOrder:"Q币对讲订单",//Q币对讲订单
      transaction:"交易明细",

    }
  },
  drawer:{
    title:{
      orderRenew:"续签订单",//续签订单
      orderChange:"改签订单",//改签订单
    }
  },
  batch:{
    info:{
      termination:"请选择需要终止的终端！",
      orderData:"订单数据",
      pleaseOrderNumber:"请选择订单号",
      batchOrderHint:"要批量绑订单，请先解绑选择用户当前已有的订单",
      secondaryEnterprise:"请选择二级企业",
      changeQb:"请选择qb数据或用户id",
      unbound:"已取消绑定",//
      changeOrderUser:"是否一键绑定当前所选用户",
      hint:"提示",
      confirm:"确定",
      cancel:"取消",
      canceledUnbound:"已取消解绑",//已取消解绑
      unboundUser:"是否一键解绑当前所选用户",
      batchSaveSecondry:"是否批量设置二级管理",
      canceleSet:"取消设置",
    }
  },
  errMsg,
  constant,
  table,
  operationLog,
  search,
  placeholder,

  qbLog,
  confirm,
  html,
  order,
  payLog,
  store,

};



// WEBPACK FOOTER //
// ./src/api/lang/zh.js